import Vue from 'vue'
import { HOST_URL, API_URL } from '../../api'
import router from '../../router'
import * as types from '../action-types'

const state = {
    authUser: null,
    loading: false,
    errors: null,
    token: null,
    refresh_token: null,
    error_msg: null,
    userUpdate: {
        updatedUser: null,
        updatingUser: false,
        updateUserStatus: null,
        updateUserMessage: null
    },
    redirectRoute: null, // Store the route the user attempted to access

}

const mutations = {
    ['SET_USER_PROFILE_UPDATE'](state, change) {
        state.userUpdate = { ...state.userUpdate, ...change };
    },
    [types.LOGIN_USER](state, status = true) {
        state.loading = status
        state.error_msg = null
    },
    [types.USER_LOGGED_IN](state, userTokens) {
        state.loading = false
        state.token = userTokens.access_token
        state.refresh_token = userTokens.refresh_token
        state.error_msg = null
    },
    [types.USER_LOGIN_FAILED](state, error) {
        state.loading = false
        state.token = null
        state.refresh_token = null
        state.authUser = null
        state.error_msg = error
    },
    [types.SET_AUTHENTICATED_USER](state, userObj) {
        state.authUser = userObj
        state.loading = false
    },
    [types.SET_USER_FROM_COOKIE](state, tokens) {
        state.token = tokens.token
        state.refresh_token = tokens.refreshToken
    },
    [types.GETTING_USER](state) {
        state.loading = true
    },

    [types.LOGOUT_USER](state) {
        state.token = null
        state.loading = false
        state.refresh_token = null
        state.authUser = null
    },
    setRedirectRoute(state, route) {
        state.redirectRoute = route; // Save the attempted route
      },
}

const actions = {
    getAuthUser: ({ commit }) => {
        // console.log('starting getting user')
        commit(types.GETTING_USER)
        return Vue.http.get(API_URL + '/user')
    },
    updateUser: ({ commit }, payload) => {
        commit('SET_USER_PROFILE_UPDATE', { updateUserStatus: null, updatedUser: null, updatingUser: true })
        return Vue.http.post(API_URL + '/users/update/' + payload.userStorer.id, payload.userStorer)
            .then(response => {
                if (payload.is_user_profile) {
                    commit(types.SET_AUTHENTICATED_USER, response.body.results.user);
                }
                commit('SET_USER_PROFILE_UPDATE', { updateUserStatus: 'success', updatedUser: response.body.results.user });
            })
            .catch(response => {
                commit('SET_USER_PROFILE_UPDATE', { updateUserStatus: 'failed', updateUserMessage: response.body.errors.message });
            })
            .finally(() => {
                commit('SET_USER_PROFILE_UPDATE', { updatingUser: false });
            })
        // .then(({ body }) => {
        //     if (body.status === 'success') {
        //         commit(types.PROFILE_UPDATED)
        //         payload.store.dispatch('refreshAuthUser', { store: payload.store, localStorage: payload.localStorage })
        //         return body;
        //     } else {
        //         commit(types.PROFILE_UPDATED) // to toggle isProcessing
        //         return body;
        //     }
        // })
    },
    loginUser: ({ commit, state }, payload) => {
        commit(types.LOGIN_USER)
        let options = {
            grant_type: 'password',
            client_id: window.Laravel.client.id, // process.env.MIX_CLIENT_ID,
            client_secret: window.Laravel.client.secret, // process.env.MIX_CLIENT_SECRET,
            username: payload.username,
            password: payload.password,
            scope: ''
        }
        Vue.http.post(HOST_URL + '/oauth/token', options)
            .then(response => {
                commit(types.USER_LOGGED_IN, response.body)
                Vue.cookie.set('token', state.token, 365)
                Vue.cookie.set('refresh_token', state.refresh_token, 365)
                payload.store.dispatch('getAuthUser')
                    .then(user => {
                        commit(types.SET_AUTHENTICATED_USER, user.body)
                        // console.log(state.authUser)
                        payload.localStorage.set('authUser', JSON.stringify(state.authUser))
                        // let path = '/home'
                        // if (state.redirect) {
                        //     path = state.redirect
                        // } else {
                        //     path = '/' + state.authUser.userable_type
                        // }
                        const redirectRoute = state.redirectRoute || '/' + state.authUser.userable_type;
                        commit('setRedirectRoute', null); // Clear the stored redirect route
                        router.push(redirectRoute); // Redirect after login
                        // router.push(path)
                    }, response => {
                        commit(types.USER_LOGIN_FAILED, 'Login Failed')
                    })

            }, response => {
                // console.log('getting something failed', response)
                commit(types.USER_LOGIN_FAILED, 'Login Failed')
            })
    },
    setAuthUser({ commit, state }, user) {
        commit(types.SET_AUTHENTICATED_USER, user);
    },
    refreshAuthUser: ({ commit }, payload) => {
        payload.store.dispatch('getAuthUser')
            .then(response => {
                commit(types.SET_AUTHENTICATED_USER, response.body)
                payload.localStorage.set('authUser', JSON.stringify(state.authUser))
            }, response => {
                commit(types.LOGIN_USER, false)
                commit(types.LOGOUT_USER)
                Vue.cookie.delete('token')
                Vue.cookie.delete('refresh_token')
                Vue.prototype.localStorage.remove('authUser')
            })
    },
    logoutUser: ({ commit }, noRouting) => {
        commit(types.LOGOUT_USER)
        Vue.cookie.delete('token')
        Vue.cookie.delete('refresh_token')
        Vue.localStorage.remove('authUser')
        if (noRouting === true) {
            return;
        }
        router.push({ path: '/login' })
    },
}

export default {
    state, mutations, actions
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/userStore.js